import { render, staticRenderFns } from "./EmailGrid.vue?vue&type=template&id=3d645d60&scoped=true"
import script from "./EmailGrid.vue?vue&type=script&lang=js"
export * from "./EmailGrid.vue?vue&type=script&lang=js"
import style0 from "./EmailGrid.vue?vue&type=style&index=0&id=3d645d60&prod&lang=scss&scoped=true"
import style1 from "./EmailGrid.vue?vue&type=style&index=1&id=3d645d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d645d60",
  null
  
)

export default component.exports